<template>
  <div class="fleet-types-carousel">
    <swiper ref="swiper" :options="options" dir="rtl">
      <swiper-slide v-for="type in types" :key="type.id">
        <!-- :class="{'active': selectedVesselType==='{{$category->title}}'}" @click="changeVesselType('{{$category->title}}')" -->
        <button type="button">
          <i :class="type.icon"></i>
          <p>{{type.title}}</p>
        </button>
      </swiper-slide>
    </swiper>

    <div class="navigation">
      <button type="button" class="button-prev" @click="prevSlide">
        <i class="icon-arrow-left"></i>
      </button>
      <button type="button" class="button-next" @click="nextSlide">
        <i class="icon-arrow-right"></i>
      </button>
    </div>
  </div>
</template>

<script>
  import {
    Swiper,
    SwiperSlide
  } from 'vue-awesome-swiper'

  export default {
    components: {
      Swiper,
      SwiperSlide
    },
    props: {
      types: {
        type: Array,
        required: true,
        default: () => {
          return []
        }
      }
    },
    data() {
      return {
        options: {
          slidesPerView: 1,
          spaceBetween: 3,
          navigation: {
            nextEl: '.button-next',
            prevEl: '.button-prev'
          },
        }
      }
    },
    methods: {
      nextSlide() {
        this.$refs['swiper'].$swiper.slideNext()
      },
      prevSlide() {
        this.$refs['swiper'].$swiper.slidePrev()
      },
    },
  }
</script>

<style scoped lang="scss">
  .fleet-types-carousel {

    

    .navigation {
      position: absolute;
      bottom: 15px;
      right: 7px;

      button {
        i {
          &::before {
            color: #fff;
            font-size: 1.5rem;
          }
        }

        &.button-prev {
          margin-right: 20px;
        }
      }
    }
  }
</style>